import type { ChipProps, FormControlLabelProps, Palette, PaletteColor } from '@mui/material';
import { Checkbox, Chip, FormControlLabel, Radio, Switch, Typography, chipClasses, styled } from '@mui/material';

export type LookoSwitchType = {
  disabled?: boolean;
  label?: React.ReactNode;
  checked?: FormControlLabelProps['checked'];
  onChange?: FormControlLabelProps['onChange'];
};
/**
 * Looko Radio
 * @see https://www.figma.com/file/PFrAvDaThtf8qMSRc9pNaV/LDS(Looko-Design-System)?node-id=2747%3A8831&mode=dev
 */
export const LookoSwitch = styled((props: LookoSwitchType) => {
  return <FormControlLabel label={''} {...props} control={<Switch size="medium" />} sx={{ margin: 0 }} />;
})(({ theme }) => {
  return {
    '& .MuiTypography-root': { fontSize: 14, fontWeight: '400' },
    p: 0,
  };
});
